import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { AllContainerLogBookResponseModel, ContainerLoadingReportResponseModel, ContainerLogBookDTO, ContainerLogBookResponseModel, FileUploadResponse, LoadingReportResponse, ProductInfoResponseDto, RowDataResponse } from "@gtpl/shared-models/logistics";
import { CommonResponse, PlantIdRequest } from "@gtpl/shared-models/warehouse-management";
import { SaleOrderIdRequest } from "@gtpl/shared-models/procurement-management";
import { Injectable } from "@nestjs/common";
import appSettings from "apps/services/config";
import { getManager } from "typeorm";
import { ContainerLogBook } from "./container-log-book.entity";
import { ContainerLogBookDto } from "./dto/container-log-book.dto";
import { ContainerLogBookAdapter } from "./repository/container-log-book.adapter";
import { ContainerLogBookRepository } from "./repository/container-log-book.repository";

@Injectable()
export class ContainerLogBookService {
    constructor(private repository: ContainerLogBookRepository,private adapter: ContainerLogBookAdapter) { }

    async updatePath(filePath: string,containerLogBookId: number): Promise<FileUploadResponse> {
        try{
            const filePathUpdate = await this.repository.update(
                { containerLogBookId: containerLogBookId },
                { filePath: filePath }
              );
              if (filePathUpdate.affected > 0) {
                return new FileUploadResponse( true, 11, 'uploaded successfully',filePath);
              }
              else{
                return new FileUploadResponse( false, 11, 'uploaded failed',filePath);
              }
        }
        catch(error){   
            console.log(error); 
        }
      }
    
    async getCreateContainerLogBook(req:ContainerLogBookDto,isUpdate: boolean): Promise<ContainerLogBookResponseModel> {
        try{
            const convertedDepartmentEntity: ContainerLogBook = this.adapter.convertDtoToEntity(req,isUpdate);
            const savedDepartmentEntity: ContainerLogBook = await this.repository.save(
            convertedDepartmentEntity
            );
            const savedDepartmentDto: ContainerLogBookDto = this.adapter.convertEntityToDto(savedDepartmentEntity);
            if (savedDepartmentDto) {
            // generating resposnse
            return new ContainerLogBookResponseModel(true, 1001, "Container Log Saved Successfully. ", savedDepartmentDto);
            } else {
            throw new ErrorResponse(11106,'Department saved but issue while transforming into DTO');
            }
        }
        catch(error){   
            console.log(error); 
        }
    }
    async getContainerLogDetails(): Promise<AllContainerLogBookResponseModel> {
        try{
            const containerLogBookDTO: ContainerLogBookDTO[] = [];
        const containerLogBookEntities: ContainerLogBook[] = await this.repository.find({
            relations: ["logBookInfo"],
        });
            if (containerLogBookEntities) {
                containerLogBookEntities.forEach(containerLogBookEntity => {
                const convertedstatesDto: ContainerLogBookDto = this.adapter.convertEntityToDto(
                    containerLogBookEntity
                );
                containerLogBookDTO.push(convertedstatesDto);
                });
                const response = new AllContainerLogBookResponseModel(true,11108,"Container Log Book retrieved successfully",containerLogBookDTO);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        }catch(error){   
            console.log(error); 
        }
    }
    async getContainerLoadingReport(req: SaleOrderIdRequest): Promise<ContainerLoadingReportResponseModel> {
        try{
            
            // for (const res of ProductCategoryDropDown){
            //     console.log(res)
            // }
            //console.log(req,'---so id--')
            const manager = getManager()
            if(req.saleOrderId != undefined){
                let containerData =  await this.repository.findOne({saleOrderId: req.saleOrderId});
                console.log(containerData);
                if(containerData != undefined){

                    const query = "select sk.sku_code_id AS skuCodeId, sk.variant_code AS variantCode, si.sale_order_item_id AS saleOrderItemId from "+appSettings.sales_db+".sale_order_items si left join "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id where si.sale_order_id = "+req.saleOrderId;
                    const data = await manager.query(query);

                    let rowsData = "SELECT lb.row AS row, SUM(cartons) AS totalCartons from "+appSettings.logistics_db+ ".log_book_items lb where container_log_book_id ="+containerData.containerLogBookId + " group by lb.row";
                    const rowDetails = await manager.query(rowsData);
                    console.log(rowDetails);
                    let rowItemDetails : RowDataResponse[] = [];
                    for (const res of rowDetails) {
                        let productInfo : ProductInfoResponseDto[] = [];
                        for (const res1 of data) {
                            let productCartons  = "SELECT sk.variant_code AS product,lb.cartons AS carton from "+appSettings.logistics_db+".log_book_items lb left join "+appSettings.sales_db+".sale_order_items si on si.sale_order_item_id = lb.sale_order_item_id left join "+appSettings.masters_db+".sku_codes sk on sk.sku_code_id = si.varient_id where lb.row = '" + res.row + "' and lb.container_log_book_id = "+containerData.containerLogBookId+" and lb.sale_order_item_id = "+res1.saleOrderItemId;
                            const rowData = await manager.query(productCartons);
                            if(rowData.length > 0){
                                let productInfoResponse = new ProductInfoResponseDto(rowData[0].product,rowData[0].carton);
                                productInfo.push(productInfoResponse)
                            }
                            else{
                                let productInfoResponse = new ProductInfoResponseDto(res1.variantCode,0);
                                productInfo.push(productInfoResponse)
                            }
                                
                        }
                        let rowDataResponse = new RowDataResponse(res.row,res.totalCartons,productInfo);
                        rowItemDetails.push(rowDataResponse);
                    }
                    // console.log(rowItemDetails);
                    let resdata = new LoadingReportResponse(containerData.containerLogBookId,containerData.saleOrderId,containerData.containerNo,containerData.loadingStartTime,containerData.loadingEndTime,containerData.loadingDate,containerData.filePath,containerData.fileName,rowItemDetails);
                    if(rowItemDetails.length > 0)
                    {
                        return new ContainerLoadingReportResponseModel(true,1001,"Loading Report retrived successfully",resdata);
                    }
                    else{
                        return new ContainerLoadingReportResponseModel(false, 1010,"no data found",);
                    }
                }
                else{
                    return new ContainerLoadingReportResponseModel(false, 1010,"no data found",);
                }
            }
            else{
                return new ContainerLoadingReportResponseModel(false, 1010,"no data found",);
            }
        }catch(error){   
            console.log(error); 
        }
    }

    async getSaleOrderDropdown(req:PlantIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = await manager.query("SELECT soi.sale_order_id AS saleOrderId, po_number AS poNumber from "+appSettings.logistics_db+".container_log_book clb left join "+appSettings.sales_db+".so_invoice_details soi on soi.sale_order_id = clb.sale_order_id where unit_id ="+req.plantId);
            if (query.length > 0) {
                return new CommonResponse(true,1001,"Sale Orders retrived successfully",query);
            } else {
                return new CommonResponse(false,1010,"no data found",query);
            }
        }catch(error){   
            console.log(error); 
        }
    }

}